import {
    DrivewealthInvestmentStrategyState,
    FetchState,
    FlatManagedPortfolioResponse,
} from "@/shared/types";
import * as storeHelper from "@/shared/storeHelper";
import * as drivewealthService from "@/shared/api/drivewealthService";
import _ from "lodash";
import { defineStore } from "pinia";
import { templatedFetchKeyStore } from "@/shared/store/fetchKeyedPlugin";

export const initialState: DrivewealthInvestmentStrategyState = {
    managedPortfolio: null,
};

export const useDrivewealthInvestmentStrategy = defineStore("drivewealthInvestmentStrategy", {
    state: (): DrivewealthInvestmentStrategyState => (_.cloneDeep(initialState)),
    getters: {
        portfolioId: state => state.managedPortfolio.portfolioId,
    },
    actions: {
        setManagedPortfolio (portfolio: FlatManagedPortfolioResponse) {
            this.managedPortfolio = portfolio;
        },
    }
});